module.exports = __webpack_public_path__ + "img/logo.7ddae553.jpg";